
export const CONSTANT = {
  URL: {
    API: "https://beta.tmmsapi.trendmicro.com",
    MYACCOUNT: "http://gr.trendmicro.com/GREntry/NonPayment?TARGET=Portal&FUNID=MyAccount&LOCALE=",
    HELP_CENTER: "https://helpcenter.trendmicro.com",
    COOKIE_NOTICE: "https://www.trendmicro.com/cookie-notice",
    OSM_QUERY_ADDRESS: "https://nominatim.openstreetmap.org/reverse?format=jsonv2"
  },
  API: {
    DEVICE: "device",
    DEVICE_COMMAND: "tmpnCommand",
    DEVICE_COMMAND_STATUS: "deviceCommandStatus",
    DEVICE_LOCATION: "deviceLocation",
    DEVICE_STATUS: "deviceStatus",
    LOGIN: "login",
    LOGOUT: "logout",
  },
  DEVICE_COMMAND: {
    LOCATE: "LOCATE",
    ALARM: "SCREAM",
    LOCK: "LOCK",
    WIPE: "WIPE",
  },
  DEVICE_COMMAND_STATUS: {
    SAVED: "CS000",
    PUSH_SENT: "CS001",
    PUSH_RESENT: "CS002",
    CLIENT_RECEIVED: "CS003",
    CLIENT_EXECUTED: "CS004",
    REACH_RETRY_LIMIT: "CS005",
    FAILED: "CS006",
    DONE: "CS007",
  },
  BING_MAP_KEY: "Aup8-oo8Klh54NZ_et0b1a4j2qi8lagIroJbc30K-8h9WmlfUhIrHGfqC96z9AYG",
};
